var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "navbar-item has-dropdown is-hoverable" }, [
    _c("div", { staticClass: "navbar-link" }, [
      _c("img", {
        staticClass: "flags-size",
        attrs: {
          src: `https://flagcdn.com/w20/${_vm.getLocalFlagString()}.png`,
          alt: "flag",
        },
      }),
      _c("span", { staticClass: "ml-2" }, [
        _vm._v(_vm._s(_vm.$i18n.locale.toUpperCase())),
      ]),
    ]),
    _c("div", { staticClass: "navbar-dropdown" }, [
      _c(
        "div",
        {
          staticClass: "navbar-item hoverable",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.setLocale("en")
            },
          },
        },
        [
          _c("img", {
            staticClass: "flags-size",
            attrs: {
              src: "https://flagcdn.com/w20/us.png",
              alt: "english flag",
            },
          }),
          _c("span", [_vm._v("English")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "navbar-item",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.setLocale("fr")
            },
          },
        },
        [
          _c("img", {
            staticClass: "flags-size",
            attrs: {
              src: "https://flagcdn.com/w20/fr.png",
              alt: "french flag",
            },
          }),
          _c("span", [_vm._v("Français")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "navbar-item",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.setLocale("ru")
            },
          },
        },
        [
          _c("img", {
            staticClass: "flags-size",
            attrs: {
              src: "https://flagcdn.com/w20/ru.png",
              alt: "Russian flag",
            },
          }),
          _c("span", [_vm._v("Pусский")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "navbar-item",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.setLocale("es")
            },
          },
        },
        [
          _c("img", {
            staticClass: "flags-size",
            attrs: {
              src: "https://flagcdn.com/w20/es.png",
              alt: "Spanish flag",
            },
          }),
          _c("span", [_vm._v("Español")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "navbar-item",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.setLocale("pt")
            },
          },
        },
        [
          _c("img", {
            staticClass: "flags-size",
            attrs: {
              src: "https://flagcdn.com/w20/pt.png",
              alt: "Português flag",
            },
          }),
          _c("span", [_vm._v("Português")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "navbar-item",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.setLocale("kr")
            },
          },
        },
        [
          _c("img", {
            staticClass: "flags-size",
            attrs: {
              src: "https://flagcdn.com/w20/kr.png",
              alt: "Korean flag",
            },
          }),
          _c("span", [_vm._v("한국어")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "navbar-item",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.setLocale("cn")
            },
          },
        },
        [
          _c("img", {
            staticClass: "flags-size",
            attrs: {
              src: "https://flagcdn.com/w20/cn.png",
              alt: "chinese flag",
            },
          }),
          _c("span", [_vm._v("普通话")]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }